module.exports = __webpack_public_path__ + "img/mail.70c60686.svg";